import { Avatar, Card, Stack, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const tokens = {
  ink: "#12242E",
  teal: "#0F8B8D",
  line: "rgba(18,36,46,0.10)",
};

const fadeInUp = {
  "@keyframes fadeInUp": {
    from: { opacity: 0, transform: "translateY(16px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
};

const SubCatList = ({ data, subCatKey, index = 0 }) => {
  const { subcategory_name, subcategory_listing } = data;
  const navigate = useNavigate();
  const initial = subcategory_name?.trim()?.charAt(0)?.toUpperCase() || "?";

  return (
    <Card
      elevation={0}
      onClick={() => navigate(`/expertlist/${subCatKey}`)}
      sx={{
        width: "100%",
        py: 3,
        px: 2,
        borderRadius: "16px",
        cursor: "pointer",
        border: `1px solid ${tokens.line}`,
        transition:
          "transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease",
        ...fadeInUp,
        animation: `fadeInUp 0.45s ease ${Math.min(index * 0.06, 0.6)}s both`,
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 12px 24px rgba(18,36,46,0.10)",
          borderColor: tokens.teal,
        },
        "&:hover .subcat-avatar": {
          transform: "scale(1.08)",
        },
      }}
    >
      <Stack spacing={1.25} alignItems="center" justifyContent="flex-start">
        <Avatar
          className="subcat-avatar"
          sx={{
            bgcolor: `${tokens.teal}1a`,
            color: tokens.teal,
            fontWeight: 700,
            width: 44,
            height: 44,
            transition: "transform 0.2s ease",
          }}
        >
          {initial}
        </Avatar>
        <Typography
          sx={{
            fontSize: "12pt",
            fontWeight: 600,
            color: tokens.ink,
            textAlign: "center",
          }}
        >
          {subcategory_name}
        </Typography>
        {subcategory_listing != null && subcategory_listing !== "" && (
          <Typography
            sx={{ fontSize: "9.5pt", color: "rgba(18,36,46,0.55)" }}
          >
            {subcategory_listing} services
          </Typography>
        )}
      </Stack>
    </Card>
  );
};

export default SubCatList;